export const FETCH_SIGNED_IN_USER_SEGMENTS_REQUEST =
  "FETCH_SIGNED_IN_USER_SEGMENTS_REQUEST";
export const FETCH_SIGNED_IN_USER_SEGMENTS_SUCCESS =
  "FETCH_SIGNED_IN_USER_SEGMENTS_SUCCESS";
export const FETCH_SIGNED_IN_USER_SEGMENTS_FAILURE =
  "FETCH_SIGNED_IN_USER_SEGMENTS_FAILURE";



// WEBPACK FOOTER //
// ./src/actions/signedInUserSegments/types.js